enum Masks {
  cnpj = '99.999.999/9999-99',
  cpf = '999.999.999-99',
  phone = '(99) 99999-9999',
  date = '99/99/9999',
  cep = '99999-999',
  creditCard = '9999 9999 9999 9999',
  ie = '99.999.999-9',
  state = 'aa',
}

enum MaskType {
  FACE = 'face',
  DOCUMENT = 'document',
}

export { MaskType, Masks };
